import { Button } from '@/components/form/baseInputs/Button';
import { Link01Icon } from '@/components/icons/Link01Icon';
import { useCanEditHouseholdData } from '@/modules/authentication/hooks/useCanEditHouseholdData';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';
import { useShowEmoneyImportPanes } from '@/modules/household/ManageIntegrationDataModal/hooks/useShowEmoneyImportPanes';
import { ManageIntegrationDataModal } from '@/modules/household/ManageIntegrationDataModal/ManageIntegrationDataModal';
import { ManageIntegrationDataPane } from '@/modules/household/ManageIntegrationDataModal/ManageIntegrationDataModal.types';
import { useTrowser } from '@/modules/navigation/trowsers/trowser.context';
import { TrowserKey } from '@/modules/navigation/trowsers/trowser.types';

export function ClientCashflowsPageImportButton() {
  const { householdId } = useHouseholdDetailsContext();
  const canEdit = useCanEditHouseholdData();
  const showEmoneyImportPanes = useShowEmoneyImportPanes();
  const integrationDataTrowser = useTrowser(TrowserKey.LinkHouseholdData);

  if (!householdId || !canEdit || !showEmoneyImportPanes) {
    return null;
  }

  return (
    <>
      <Button
        variant="secondary"
        size="sm"
        startIcon={Link01Icon}
        onClick={() =>
          integrationDataTrowser.open({
            section: ManageIntegrationDataPane.ImportDataCashflows,
          })
        }
      >
        Import cash flows
      </Button>

      {integrationDataTrowser.isOpen && (
        <ManageIntegrationDataModal
          isOpen
          onClose={integrationDataTrowser.close}
          householdId={householdId}
          initialPane={ManageIntegrationDataPane.ImportDataCashflows}
        />
      )}
    </>
  );
}
